import { Schema, Value } from '@wix/cms-viewer-core'
import { FieldType } from '@wix/wix-data-schema-types'

import { adaptBuilderConnection } from './builder-connection-adapter'

const ROLE_TO_PRIMARY_PROPERTY_NAME = new Map([
  ['imageRole', 'image.src'],
  ['textRole', 'richText'],
  ['siteButtonRole', 'link'],
])

export const makeBuilderComponentAdapter = ({
  emptyValueReporter,
  environment,
  schema,
}) => (builderComponent) => {
  const connection = adaptBuilderConnection(
    builderComponent.connectionConfig,
    builderComponent.role,
    schema,
  )

  const component = {
    id: builderComponent.uniqueId,
    connection,
    setProps: (props) => {
      const { role } = builderComponent
      const propertyNameToEmptyFieldKey = new Map()

      for (const [propertyName, propertyValue] of Object.entries(props)) {
        const { fieldKey } = connection.properties[propertyName]

        const [adaptedPropertyName, adaptedSubpropertyName] = adaptPropertyName({
          fieldKey,
          propertyName,
          role,
          schema,
        })
        if (typeof adaptedSubpropertyName === 'undefined') {
          builderComponent[adaptedPropertyName] = propertyValue
        } else {
          builderComponent[adaptedPropertyName][adaptedSubpropertyName] = propertyValue
        }

        if (Value.isEmpty(propertyValue)) {
          propertyNameToEmptyFieldKey.set(propertyName, fieldKey)
        }
      }

      const primaryPropertyIsConnectedToEmptyField = ROLE_TO_PRIMARY_PROPERTY_NAME.has(role) &&
        propertyNameToEmptyFieldKey.has(ROLE_TO_PRIMARY_PROPERTY_NAME.get(role))

      if (environment === 'editor' && propertyNameToEmptyFieldKey.size > 0) {
        emptyValueReporter.reportComponentPropertiesConnectedToEmptyFields({
          componentId: component.id,
          propertyNameToEmptyFieldKey: Object.fromEntries(propertyNameToEmptyFieldKey.entries()),
          primaryPropertyIsConnectedToEmptyField,
        })
      }

      if (primaryPropertyIsConnectedToEmptyField) {
        builderComponent[environment === 'editor' ? 'hide' : 'collapse']()
      }
    },
    bind: () => {},
  }
  return component
}

const adaptPropertyName = ({
  fieldKey,
  propertyName,
  role,
  schema,
}) => {
  const propertyPath = propertyName.split('.')

  if (propertyPath.length === 1) {
    if (propertyName === 'richText' && role === 'textRole') {
      const fieldType = Schema.getFieldType(schema, fieldKey)
      const $wTextPropertyName = fieldType === FieldType.richText ? 'html' : 'text'
      return [$wTextPropertyName]
    }

    return propertyPath
  }

  if (propertyPath[0] === 'image' && role === 'imageRole') {
    return [propertyPath[1]]
  }

  if (propertyPath[0] === 'a11y') {
    return ['accessibility', propertyPath[1]]
  }

  return propertyPath
}
